export const allHtmlLinksNewWindow = (html: string) => {
    return html ? html.split('<a').join('<a target="_blank"') : html;
}